export class AFP {
  idafp?: number;
  nombre?: string;
  porcentaje?: number;
  editando?: boolean;
  constructor() {}
}
